import { useLocation, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { useEffect, useState } from "react";
import { formatToTitleCase } from "../../utils/_helpers";
import { Button, Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import "./RoleCard.css";

const AssignPermission = () => {
  const [allPermissions, setAllPermissions] = useState([]);
  const [roleTitle, setRoleTitle] = useState('');
  const location = useLocation();
  const { role: selectedRole } = location?.state || {};
  const { postData } = usePostRequest(API_ENDPOINTS.GET_PERMISSIONS);
  const navigate = useNavigate();



  // console.log("all", allPermissions);

  const onSuccess = (response) => {
    setAllPermissions(response.data || []);
    setRoleTitle(response.role?.name)
  };

  const onError = () => { };

  const handleUpdatePermissions = () => {

    const allowedPermissions = allPermissions
      ?.filter((permission) => permission.actions.length > 0)
      ?.map((permission) => ({
        id: permission.id,
        action: permission.actions,
      }));

    const payload = {
      role_id: selectedRole.id,
      permission: allowedPermissions,
    };


    postData(payload, () => {
      toast.success("Permissions updated successfully!");
    }, onError, API_ENDPOINTS.UPDATE_PERMISSIONS);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (selectedRole?.id) {
      postData({ role_id: selectedRole?.id }, onSuccess);
    }
  }, []);

  console.log("allPermissions",allPermissions)

  return (

    <>
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title"> Assign Permissions to Department : {formatToTitleCase(roleTitle)}</h2>
          </div>
        </div>
      </div>

      <Card className="col-12">
        <Card.Body>
          <Row>
            {allPermissions?.map((permission) => {
              const handleCheckboxChange = (action) => (event) => {
                setAllPermissions((prevState) =>
                  prevState.map((prevPermission) => {
                    if (prevPermission.id === permission.id) {
                      // Update the actions array based on the checkbox state (checked/unchecked)
                      const updatedActions = event.target.checked
                        ? [...prevPermission.actions, action]
                        : prevPermission.actions.filter((act) => act !== action);
                      return { ...prevPermission, actions: updatedActions };
                    }
                    return prevPermission;
                  })
                );
              };

              return (
                <Col md={4} key={permission?.id}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Card.Title className="card_heading">
                        {formatToTitleCase(permission?.show_name)}
                      </Card.Title>
                      <Card.Text>
                        Enables the user to create, update, and monitor Requests
                        for Quotations with ease.
                      </Card.Text>
                      <div className="d-flex gap-3">
                        <label className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={permission?.actions?.includes("read")}
                            onChange={handleCheckboxChange("read")}
                          />
                          <span
                            className="form-check-label"
                            style={{ color: "#212529" }}
                          >
                            Read
                          </span>
                        </label>
                        <label className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={permission?.actions?.includes("write")}
                            onChange={handleCheckboxChange("write")}
                          />
                          <span
                            className="form-check-label"
                            style={{ color: "#212529" }}
                          >
                            Write
                          </span>
                        </label>
                        <label className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={permission?.actions?.includes("delete")}
                            onChange={handleCheckboxChange("delete")}
                          />
                          <span
                            className="form-check-label"
                            style={{ color: "#212529" }}
                          >
                            Delete
                          </span>
                        </label>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          <div className="d-flex gap-2 justify-content-end mt-3">
            <Button className="btn btn-theme" onClick={handleUpdatePermissions}>
              Update Permissions
            </Button >
            <Button className="btn" variant="outline-secondary" onClick={handleCancel}>
              Cancel
            </Button >
          </div>

          {/* <div>
            {allPermissions?.map((permission) => (
              <div className="d-flex gap-2" key={permission?.id}>
                <input
                  type="checkbox"
                  checked={permission?.isAssigned}
                  value={permission?.isAssigned}
                  onChange={(event) =>
                    handleSelectPermission(event, permission)
                  }
                />
                <label>{formatToTitleCase(permission?.name)}</label>
              </div>
            ))}
          </div>

          <div className="d-flex gap-2 justify-content-end">
            <button className="btn" onClick={handleUpdatePermissions}>
              Update Permission
            </button>
            <button className="btn" onClick={handleCancel}>
              Cancel
            </button>
          </div> */}
        </Card.Body>
      </Card>

    </>


  );
};

export default AssignPermission;
